import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { classNames } from 'primereact/utils';
import { PrimeIcons } from 'primereact/api';
import { CANCELED_BY_OPTIONS, Reservation } from '../../../types/reservation';
import { cancellationReasonOptions } from '../constants';

interface Props {
  resource: Reservation | undefined;
}

/** Shows who canceled the reservation, when and why. */
export const CancellationBanner = ({ resource }: Props) => {
  return (
    <div className='cancellation-info warning'>
      <div className='warning-title'>
        <i className={classNames(PrimeIcons.EXCLAMATION_TRIANGLE, 'warning-icon')} />
        <span>Esta reserva ha sido cancelada</span>
      </div>
      <div className='cancellation-details'>
        <p>
          <strong>Cancelada por:</strong>
          {resource?.canceledBy === CANCELED_BY_OPTIONS.CANCELED_BY_ADMIN ? 'Empleado' : 'Cliente'}
        </p>
        {resource?.cancellationDate && (
          <p>
            <strong>Fecha de cancelación:</strong>
            {format(new Date(resource.cancellationDate), "d 'de' MMMM 'de' yyyy 'a las' HH:mm", { locale: es })}
          </p>
        )}
        <p>
          <strong>Motivo:</strong>
          {cancellationReasonOptions.find((option) => option.value === resource?.canceledReason)?.label ??
            resource?.canceledReason}
        </p>
      </div>
    </div>
  );
};
